// extracted by mini-css-extract-plugin
export default {"navigation_container":"NavigationTitle_navigation_container__LcU-U","back_icon":"NavigationTitle_back_icon__y+NEA","text_container":"NavigationTitle_text_container__ECEDA"};